<template>
  <div class="flex justify-end"
       :class="{'text-text-ternary':value === 0,
                'text-red':value < 0}">
    <div>{{ formattedCurrencyValue(value) }}</div>
    <div class="w-20 ml-4"
         :class="{'text-green':percent > 0,
                  'text-red':percent < 0}">
      {{ percent }} %
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ValueWIndicator",
  props: {
    value: {
      type: Number,
      default: 0.00
    },
    percent: {
      type: Number,
      default: 0.00
    }
  },
  computed:{
    ...mapGetters('cabinet/currencies',['formattedCurrencyValue'])
  }
}
</script>